module.exports = __webpack_public_path__ + "img/shop.8f275b9.svg";